import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../lib/theme';

/**
 * Phase 25 — Safety-net route.
 *
 * The actual OAuth exchange happens on the backend at
 * ``GET /api/quickbooks/callback`` which then redirects the browser to
 * ``/app/settings?qb=connected#integrations``. This component only runs if
 * someone hits ``/quickbooks/callback`` on the frontend origin directly
 * (e.g. a stale bookmark). In that case we just bounce them to the
 * Integrations tab.
 */
export default function QuickBooksCallback() {
  const navigate = useNavigate();
  const { colors } = useTheme();

  useEffect(() => {
    const t = setTimeout(() => navigate('/app/settings#integrations', { replace: true }), 800);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div
      data-testid="qb-callback-fallback"
      style={{
        minHeight: '100vh',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: colors.bg, color: colors.text,
        fontFamily: 'system-ui, -apple-system, sans-serif',
      }}
    >
      <div
        style={{
          padding: '28px 32px', borderRadius: 14,
          border: `1px solid ${colors.border}`, background: colors.surface,
          textAlign: 'center', maxWidth: 420,
        }}
      >
        <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 6 }}>
          Connecting QuickBooks…
        </div>
        <div style={{ color: colors.textMuted, fontSize: 13 }}>
          Taking you back to Clasifi.
        </div>
      </div>
    </div>
  );
}
